import React, { useEffect, useState } from "react";
import { cn } from "../../utils/utils";
type propsType = {
  onClick?: () => void;
  state: boolean;
  isDisabled?: boolean;
  customClassName?: string;
};
const Toggle = ({
  onClick,
  state,
  customClassName,
  isDisabled = false,
}: propsType) => {
  // const [checked, setChecked] = useState(state);

  // //

  const handelCheck = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onClick ? onClick() : "";
  };

  // useEffect(() => {
  //   setChecked(state);
  // }, [state]);
  return (
    <label className="inline-flex items-center cursor-pointer h-fit">
      <input
        onChange={() => {
          handelCheck();
        }}
        type="checkbox"
        disabled={isDisabled}
        checked={state}
        className="sr-only peer"
      />
      <div
        className={cn(
          `relative w-11 h-6 bg-gray-200 peer-focus:outline-none    rounded-full peer  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-primary peer-checked:dark:bg-primaryYellow`,
          customClassName
        )}
      ></div>
    </label>
  );
};

export default Toggle;
